import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitLead = async (type, payload) => {
    const { data } = await api.post(`/leads/${type}`, payload);
    return data;
};
